import { useState } from "react";
import { Box, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SigninLayout from "../../../layout/SigninLayout";
import MaterialInput from "../../../components/MaterialInput";
import leftlogo from "../../../assest/LoginBackground.png";
import { loginPostData } from "../../Utils/Baseurl";
import { useAuth } from "../../../context/AuthContext";
import "./index.css";
import MaterialTypography from "../../../components/MaterialTypography";
import { useSnackbar } from "../../../components/SnackbarProvider";
import { useLoading } from "../../../context/loadingcontext";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import logo from '../../../assest/Soucient1.png'
import LoginIcon from "@mui/icons-material/Login";
import { keyframes } from "@mui/system";


const shake = keyframes`
  10%, 90% { transform: translate3d(-1px, 0, 0) rotateZ(-90deg); }
  20%, 80% { transform: translate3d(1px, 0, 0) rotateZ(-90deg); }
  30%, 50%, 70% { transform: translate3d(-1px, 0, 0) rotateZ(-90deg); }
  40%, 60% { transform: translate3d(1px, 0, 0) rotateZ(-90deg); }
`;

const moveUp = keyframes`
  0% { margin-top: 0; transform: scale(1) rotateZ(-90deg); }
  100% { color: #4caf50; margin-top: -100px; transform: scale(0) rotateZ(-90deg); }
`;

function Signin() {
  const navigate = useNavigate();
  const { setCurrentUser, setAuthenticated } = useAuth();
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();

  const [status, setStatus] = useState("idle");
  const [loading, setLoading] = useState(false);

  const [signInData, setSignInData] = useState({
    email: "",
    password: null,
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSignIn(event);
    }
  };


  // sessionStorage.setItem("roles", JSON.stringify(roles));

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = { ...signInData };

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    switch (name) {
      case "email":
        updatedData.email = value;
        updatedData.emailStatus = validateEmail(value) ? "success" : "error";
        break;

      case "password":
        updatedData.password = value;
        updatedData.passwordStatus = "success";
        break;

      default:
        break;
    }

    setSignInData(updatedData);
  };

  /**
   * Handles the signin functionality by sending a POST request to the
   * login endpoint. If the response is successful, it sets the
   * authenticated state to true, sets the current user to the
   * logged-in user, and navigates to the dashboard page.
   * If the response is unsuccessful, it shows an error message and
   * clears the session storage.
   * @param {Event} event - The signin form submission event.
   */
  // const handleSignIn = async (event) => {
  //   if (event) event.preventDefault();

  //   setCirleLoading(true);
  //   const { email, password } = signInData;
  //   try {
  //     const response = await loginPostData("api/login/", { email, password });
  //     console.log(response, "responseeee");
  //     if (response.status === true) {
  //       sessionStorage.setItem("token", response?.data?.access);
  //       sessionStorage.setItem("refresh_token", response?.data?.refresh);
  //       sessionStorage.setItem("user_id", response?.data?.user_id);
  //       sessionStorage.setItem("email", response?.data?.email);
  //       sessionStorage.setItem("first_name", response?.data?.first_name);
  //       sessionStorage.setItem("last_name", response?.data?.last_name);
  //       // sessionStorage.setItem(
  //       //   "role",
  //       //   JSON.stringify(response.role_permission)
  //       // );
  //       sessionStorage.setItem("currentUser", JSON.stringify(response?.user));
  //       sessionStorage.setItem(
  //         "authenticated",
  //         JSON.stringify(response?.status)
  //       );
  //       setAuthenticated(response?.status);
  //       setCurrentUser(response?.data?.user_id);
  //       showSnackbar("Login Successfully", "success");
  //       navigate("/dashboard")
  //       // navigate("/landing-page");
  //       // window.location.reload();
  //     } else {
  //       showSnackbar(response.message, "error");
  //       sessionStorage.clear();
  //     }
  //   } catch (error) {
  //     let message = "An unexpected error occurred";
  //     if (error?.response?.data?.message) {
  //       message = error.response.data.message;
  //     } else if (error?.message) {
  //       message = error.message;
  //     }

  //     showSnackbar(message, "error");
  //   } finally {
  //     setCirleLoading(false);
  //   }
  // };

  const handleSignIn = async (event) => {
    if (event) event.preventDefault();
    setStatus("logging");
    setLoading(true);

    const { email, password } = signInData;

    try {
      const response = await loginPostData("api/login/", { email, password });


      if (response.status === true) {

        sessionStorage.setItem("token", response?.access);
        sessionStorage.setItem("refresh_token", response?.refresh);
        sessionStorage.setItem("user_id", parseInt(response?.user?.id));
        sessionStorage.setItem("email", JSON.stringify(response?.user?.email));
        sessionStorage.setItem("profile_image", JSON.stringify(response?.user?.profile_image));
        sessionStorage.setItem("first_name", JSON.stringify(response?.user?.employee_name));
        sessionStorage.setItem("last_name", response?.data?.last_name);
        sessionStorage.setItem("currentUser", parseInt(response?.user?.id));
        sessionStorage.setItem("authenticated", JSON.stringify(response?.status));
        sessionStorage.setItem("user_role", response?.user?.role?.role);
        sessionStorage.setItem("role", JSON.stringify(response.role_permission));
        sessionStorage.setItem("team", response?.user?.team?.team_name)

        setAuthenticated(response?.status);
        setCurrentUser(response?.data?.user_id);
        showSnackbar("Login Successfully", "success");

        setTimeout(() => setStatus("loggedIn"), 1000);
        setTimeout(() => navigate("/dashboard"), 2000);
      } else {
        showSnackbar(response.message, "error");
        sessionStorage.clear();
        setStatus("idle");
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
      setStatus("idle");
    } finally {
      setLoading(false);
    }
  };

  return (
    <SigninLayout
      description="Enter your email and password to sign in"
      illustration={leftlogo}
    >

      <Grid
        container
        direction='column'
        spacing={1}
        p={3}
        sx={{ display: 'flex', justifyContent: 'center', }}
        onKeyDown={handleKeyDown}
      >
        <Grid
          size={{ xs: 12, lg: 12 }}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <Box
            component="img"
            src={logo}
            alt="Image not loaded"
            sx={{
              width: { xs: '80%', sm: '40%' },
              height: { xs: '80%', sm: '40%' },
              justifyContent: 'center',
              textAlign: 'center',
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 12 }}>
          <Box sx={{ textAlign: "center" }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                variant="h3"
                color="#1c1b3b"
                fontWeight="bold"
                sx={{ fontSize: "30px", fontFamily: "'Archivo Black', sans-serif", }}
              >
                Welcome to Project <br />Management
              </MaterialTypography>
              <MaterialTypography
                variant="h5"
                color="text"
                sx={{ fontSize: "14px" }}
              >
                Sign in to your account
              </MaterialTypography>
            </Stack>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 12 }} sx={{
          display: 'flex',
          justifyContent: 'center',
        }}>
          <Stack
            direction="column"
            spacing={1}
            sx={{ width: '100%', maxWidth: '350px' }}
          >
            <MaterialTypography variant="caption" color="text">
              Email Address
            </MaterialTypography>
            <MaterialInput
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={signInData.email}
              onChange={handleChange}
              error={signInData.emailStatus === "error"}
              helperText={
                signInData.emailStatus === "error"
                  ? "Please enter a valid email address"
                  : ""
              }
              sx={{ width: '100%' }}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 12 }} sx={{
          display: 'flex',
          justifyContent: 'center',
        }}>
          <Stack
            direction="column"
            spacing={1}
            sx={{ width: '100%', maxWidth: '350px' }}
          >
            <MaterialTypography variant="caption" color="text">
              Password
            </MaterialTypography>
            <MaterialInput
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your password"
              value={signInData.password}
              onChange={handleChange}
              error={signInData.passwordStatus === "error"}
              helperText={
                signInData.passwordStatus === "error"
                  ? "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character."
                  : ""
              }
              sx={{ width: '100%' }}
              endAdornment={(
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleTogglePassword}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 12 }} sx={{ mt: 1 }}>
          <Stack direction="row" justifyContent="space-evenly">
            <Box style={{ marginTop: "-14px" }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Remember me"
                />
              </FormGroup>
            </Box>
            <Box>
              <MaterialTypography
                sx={{ color: "dark", cursor: "pointer", fontSize: "14px" }}
                onClick={() => navigate("/forgot-password")}
              >
                Forgot Password?
              </MaterialTypography>
            </Box>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 12 }} mt={1}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* <MaterialButton
              variant="contained"
              color="dark"
              size="small"
              sx={{
                borderRadius: "20px",
                width: "130px",
                background: "#76BAF0",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "16px",
                textTransform: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: "linear-gradient(to right top, #8456e2, #6f62eb, #556df3, #2f77f9)",
                  transform: "scale(1.05)",
                },
              }}
              // type="submit"
              onClick={handleSignIn}
            >
              Sign In
            </MaterialButton> */}
            <Box
              onClick={handleSignIn}
              sx={{
                position: "relative",
                width: "180px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mx: "auto",
                mt: 2,
              }}
            >
              {/* Message */}
              <Box
                sx={{
                  fontSize: "10px",
                  color: "#fff",
                  py: 1,
                  px: 1,
                  borderRadius: "40px",
                  textAlign: "center",
                  width: "80%",
                  transition: "0.3s ease background-color, 0.3s ease box-shadow",
                  backgroundColor:
                    status === "logging"
                      ? "#efdb83ff"
                      : status === "loggedIn"
                        ? "#65ed69ff"
                        : "#1e2a78",
                  boxShadow:
                    status === "logging"
                      ? "0 20px 30px -6px #b7a555ff"
                      : status === "loggedIn"
                        ? "0 20px 30px -6px #5fa261ff"
                        : "none",
                }}
              >
                <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "15px" }}>
                  {status === "logging"
                    ? "Logging"
                    : status === "loggedIn"
                      ? "Logged In"
                      : "Sign In"}
                </Typography>
              </Box>

              {/* Icon */}
              <IconButton
                sx={{
                  position: "absolute",
                  top: -6,
                  right: 25,
                  color: "#fff",
                  fontSize: "20px",
                  p: "18px 12px",
                  transition: "0.3s ease transform",
                  transform: "rotateZ(0deg)",
                  ...(status === "logging" && {
                    transform: "rotateZ(-90deg)",
                    animation: `${shake} 0.3s ease 0.5s infinite`,
                  }),
                  ...(status === "loggedIn" && {
                    transform: "rotateZ(-90deg)",
                    animation: `${moveUp} 1s ease 0s forwards`,
                  }),
                }}
              >
                {loading ? (
                  <CircularProgress size={20} sx={{ color: "#fff" }} />
                ) : (
                  <LoginIcon sx={{ transform: "rotate(-90deg)" }} />
                )}
              </IconButton>
            </Box>

          </Box>
        </Grid>
      </Grid>

    </SigninLayout >

  );
}

export default Signin;
